import React from "react";
import Modal from "atoms/Modal";
import Button from "atoms/Button";
import { useHistory } from "react-router-dom";

export const LogoutModal = ({ onClose, ...props }) => {
  const history = useHistory();

  const onLogout = () => {
    sessionStorage.clear();
    history.push("/");
  };

  return (
    <Modal title="Logout" onClose={onClose} {...props}>
      <div
        className="delete-trip-modal-header"
        style={{
          position: "relative",
        }}
      >
        <div className="heading-type-three">
          Are you sure you want to logout?
        </div>

        <div className="deleteButtons">
          <div style={{ width: "100%" }}>
            <Button
              style={{ marginTop: "25px" }}
              variant="secondary"
              onClick={onClose}
            >
              Cancel
            </Button>
          </div>
          <div style={{ width: "100%" }}>
            <Button style={{ marginTop: "25px" }} onClick={onLogout}>
              Logout
            </Button>
          </div>
        </div>
      </div>
    </Modal>
  );
};
